import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Avatar } from '~/components/Avatar';
import { Button } from '~/components/Button';
import { useCanEditUser } from '~/modules/settings/modules/user/hooks';
import { Header } from '~settings/components/Header';
import { SETTINGS_ROUTES } from '~settings/config/routes';

import { useUserDetail } from '../../hooks/useUserDetail';

export function UserHeader() {
  const { t } = useTranslation('settings');
  const user = useUserDetail();
  const { fullName, id } = user;

  const canEditUser = useCanEditUser(user);

  return (
    <Header
      breadcrumbItems={[
        { to: SETTINGS_ROUTES.ROOT, label: t('title'), iconType: 'gear' },
        { to: SETTINGS_ROUTES.USER_LIST, label: t('users') },
        { label: fullName },
      ]}
    >
      <div className="flex items-center gap-md">
        <Avatar name={fullName} size="lg" />
        <h1 className="break-all text-display-sm font-bold">{fullName}</h1>
      </div>
      {canEditUser ? (
        <Button asChild size="large" variant="primary">
          <Link to={SETTINGS_ROUTES.USER_EDIT(id)}>{t('user.editLink')}</Link>
        </Button>
      ) : null}
    </Header>
  );
}
UserHeader.displayName = 'UserHeader';
